<template>
  <v-main>
    <v-overlay :value="isLoading" z-index="999">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="0" rounded="xxl" class="app-card">
            <v-card-title>
              <AppPageHeader
                icon="mdi-package-variant-closed"
                :title="isDeletePage() != true ? 'Assigned Stocks' : 'Deleted Assigned Stocks'"
                subtitle="Stock handed out to distributors, franchisees and sales executives"
                style="width: 100%"
              >
                <template v-if="isDeletePage() != true">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        @click="showCreateDialog = true"
                      >
                        <v-icon dark> mdi-plus </v-icon>
                      </v-btn>
                    </template>
                    <span>Assign Stock</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="mx-2"
                        fab
                        x-small
                        color="info"
                        to="/assigned_stocks/stock-details"
                      >
                        <v-icon dark> mdi-account-group </v-icon>
                      </v-btn>
                    </template>
                    <span>Stock Per User</span>
                  </v-tooltip>
                </template>
              </AppPageHeader>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.product_id"
                    :items="products"
                    item-text="name"
                    item-value="id"
                    label="Product"
                    @input="onProductChange"
                    prepend-inner-icon="mdi-package-variant"
                    clearable
                    :no-data-text="products.length === 0 ? 'Loading products...' : 'No products available'"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="4">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.variant_id"
                    :items="variants"
                    :item-text="formatVariantName"
                    item-value="id"
                    label="Product Variant"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-package-variant-closed"
                    clearable
                    :disabled="!filter.product_id && variants.length === 0"
                    :no-data-text="!filter.product_id ? 'Select a product first or show all variants' : 'No variants available'"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.assigned_to_id"
                    :items="users"
                    item-text="display_name"
                    item-value="id"
                    label="Assigned To"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-account"
                    clearable
                    :no-data-text="users.length === 0 ? 'Loading users...' : 'No users available'"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.transporter_manager_id"
                    :items="transporterManagers"
                    item-text="display_name"
                    item-value="id"
                    label="Transporter Manager"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-truck-delivery"
                    clearable
                    :no-data-text="transporterManagers.length === 0 ? 'Loading transporters...' : 'No transporters available'"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="0" rounded="xxl" class="app-card">
            <v-card-title v-if="assignedStocks.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="500"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Product</th>
                      <th class="text-left">Variant</th>
                      <th class="text-left">Quantity</th>
                      <th class="text-left">Assigned To</th>
                      <th class="text-left">Transporter Manager</th>
                      <th class="text-left">Created By</th>
                      <th class="text-left">Created At</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="assignedStocks.length != 0">
                    <tr
                      v-for="(assignedStock, i) in assignedStocks"
                      :key="`assignedStock${i}`"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="assignedStock.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Assigned Stock is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="assignedStock.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Assigned Stock is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          assignedStock.product
                            ? assignedStock.product.name
                            : "N/A"
                        }}
                      </td>
                      <td>{{ formatVariantDisplay(assignedStock.variant) }}</td>
                      <td><v-chip small color="success" text-color="white" class="mono-figure">
                          {{ assignedStock.total_quantity }} Units
                        </v-chip></td>
                      <td>
                        <div v-if="assignedStock.assigned_to">
                          <div class="font-weight-bold">
                            {{ assignedStock.assigned_to.first_name }}
                            {{ assignedStock.assigned_to.last_name || "" }}
                          </div>
                          <div class="text-caption grey--text">
                            <v-icon small>mdi-phone</v-icon>
                            {{ assignedStock.assigned_to.phone }}
                          </div>
                        </div>
                        <span v-else class="grey--text">Not Assigned</span>
                       
                      </td>
                      <td>
                        <div v-if="assignedStock.transporter_manager">
                          <div class="font-weight-bold">
                            {{ assignedStock.transporter_manager.first_name }}
                            {{ assignedStock.transporter_manager.last_name || "" }}
                          </div>
                          <div class="text-caption grey--text">
                            <v-icon small>mdi-phone</v-icon>
                            {{ assignedStock.transporter_manager.phone }}
                          </div>
                        </div>
                        <span v-else class="grey--text">Not Assigned</span>
                      </td>
                      <td>
                        {{
                          assignedStock.created_by
                            ? assignedStock.created_by.first_name +
                              " " +
                              (assignedStock.created_by.last_name || "")
                            : ""
                        }}
                      </td>
                      <td>{{ assignedStock.created_at | niceDateTime }}</td>
                      <td style="min-width: 120px" class="text-right">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              color="info"
                              @click="openView(assignedStock)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>View</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                              fab
                              x-small
                              color="primary"
                              @click="openEdit(assignedStock)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        <!-- <v-tooltip bottom v-if="isDeletePage() != true">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              color="red"
                              class="ml-2"
                              @click="deleteAssignedStock(assignedStock.id)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip> -->
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="10">
                        <AppEmptyState
                          icon="mdi-package-variant-closed"
                          :title="isDeletePage() != true ? 'No assigned stock yet' : 'No deleted assignments'"
                          message="Assign stock to a distributor, franchisee or sales executive to see it here."
                          :action-text="isDeletePage() != true ? 'Assign Stock' : ''"
                          @action="showCreateDialog = true"
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Pagination -->
      <v-row v-if="count > rowsPerPage">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <v-pagination
                v-model="page"
                :length="Math.ceil(count / rowsPerPage)"
                @input="getData"
                color="primary"
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Delete Confirmation Dialog -->
      <v-dialog v-model="deleteDialog" max-width="500">
        <v-card rounded="xxl">
          <v-card-title class="headline">Confirm Delete</v-card-title>
          <v-card-text>
            Are you sure you want to delete this assigned stock?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="deleteDialog = false"
              >Cancel</v-btn
            >
            <v-btn color="red" text @click="confirmDelete">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Restore Confirmation Dialog -->
      <v-dialog v-model="restoreDialog" max-width="500">
        <v-card rounded="xxl">
          <v-card-title class="headline">Confirm Restore</v-card-title>
          <v-card-text>
            Are you sure you want to restore this assigned stock?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="restoreDialog = false"
              >Cancel</v-btn
            >
            <v-btn color="green" text @click="confirmRestore">Restore</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Assign Stock dialog -->
      <AppDialog
        :show.sync="showCreateDialog"
        max-width="1100"
        icon="mdi-package-variant-closed"
        title="Assign Stock"
        subtitle="Issue stock on credit to a distributor, franchisee or sales executive"
      >
        <AssignedStockCreatePage
          v-if="showCreateDialog"
          embedded
          @saved="onDialogSaved"
          @close="showCreateDialog = false"
        />
      </AppDialog>

      <!-- Edit Assigned Stock dialog -->
      <AppDialog
        :show.sync="showEditDialog"
        max-width="900"
        icon="mdi-package-variant-closed"
        :title="editingRow && editingRow.product ? editingRow.product.name : 'Edit Assigned Stock'"
        :subtitle="editingRow ? formatVariantDisplay(editingRow.variant) : ''"
      >
        <AssignedStockEditPage
          v-if="showEditDialog"
          embedded
          :assigned-stock-id="editingId"
          @saved="onDialogSaved"
          @close="showEditDialog = false"
        />
      </AppDialog>

      <!-- View Assigned Stock -->
      <AppDialog
        :show.sync="showViewDialog"
        max-width="700"
        icon="mdi-package-variant-closed"
        :title="viewingRow && viewingRow.product ? viewingRow.product.name : 'Assigned Stock'"
        :subtitle="viewingRow ? formatVariantDisplay(viewingRow.variant) : ''"
        :status-text="viewingRow ? (viewingRow.is_active ? 'Active' : 'Inactive') : ''"
        :status-color="viewingRow && viewingRow.is_active ? 'success' : 'error'"
      >
        <div class="pa-2" v-if="viewingRow">
          <v-row dense>
            <v-col cols="6" sm="4">
              <AppInfoCard icon="mdi-cube-outline" label="Total Quantity" :value="String(viewingRow.total_quantity || 0)" />
            </v-col>
            <v-col cols="6" sm="4">
              <AppInfoCard icon="mdi-cart-check" label="Sold Quantity" :value="String(viewingRow.sold_quantity || 0)" />
            </v-col>
            <v-col cols="6" sm="4">
              <AppInfoCard icon="mdi-cube" label="Available" :value="String((viewingRow.total_quantity || 0) - (viewingRow.sold_quantity || 0))" />
            </v-col>
            <v-col cols="12" sm="6">
              <AppInfoCard
                icon="mdi-account"
                label="Assigned To"
                :value="viewingRow.assigned_to ? `${viewingRow.assigned_to.first_name} ${viewingRow.assigned_to.last_name || ''} (${viewingRow.assigned_to.phone || ''})` : 'Not Assigned'"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <AppInfoCard
                icon="mdi-truck-delivery"
                label="Transporter Manager"
                :value="viewingRow.transporter_manager ? `${viewingRow.transporter_manager.first_name} ${viewingRow.transporter_manager.last_name || ''} (${viewingRow.transporter_manager.phone || ''})` : 'Not Assigned'"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <AppInfoCard
                icon="mdi-account-edit"
                label="Created By"
                :value="viewingRow.created_by ? `${viewingRow.created_by.first_name} ${viewingRow.created_by.last_name || ''}` : 'N/A'"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <AppInfoCard icon="mdi-calendar" label="Created At" :value="$options.filters.niceDateTime(viewingRow.created_at)" />
            </v-col>
          </v-row>
        </div>
      </AppDialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";
import AppDialog from "@/components/AppDialog.vue";
import AppEmptyState from "@/components/AppEmptyState.vue";
import AppPageHeader from "@/components/AppPageHeader.vue";
import AppInfoCard from "@/components/AppInfoCard.vue";
import AssignedStockCreatePage from "./create.vue";
import AssignedStockEditPage from "./id.vue";

export default {
  name: "AssignedStocksIndexPage",
  components: {
    AppDialog,
    AppEmptyState,
    AppPageHeader,
    AppInfoCard,
    AssignedStockCreatePage,
    AssignedStockEditPage,
  },
  data() {
    return {
      assignedStocks: [],
      isLoading: false,
      isExcelloading: false,
      deleteDialog: false,
      restoreDialog: false,
      selectedId: null,
      showCreateDialog: false,
      showEditDialog: false,
      editingId: null,
      editingRow: null,
      showViewDialog: false,
      viewingRow: null,
      filter: {
        search_keyword: null,
        is_active: "",
        product_id: null,
        variant_id: null,
        assigned_to_id: null,
        transporter_manager_id: null,
      },
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      products: [],
      variants: [],
      allVariants: [],
      users: [],
      transporterManagers: [],
      page: 1,
      count: 0,
    };
  },
  mounted() {
    this.fetchMasters();
    this.getData();
  },
  methods: {
    async fetchMasters() {
      try {
        // Single API call to get all dropdown data
        const response = await axios.get("/masters", {
          params: { context: "assign_stock" }
        });

        const data = response.data;

        // Products with variants
        this.products = (data.products_with_variants || []).map(product => ({
          id: product.id,
          name: product.name,
        }));

        // Flatten all variants from products_with_variants
        this.allVariants = [];
        (data.products_with_variants || []).forEach(product => {
          if (product.variants && product.variants.length > 0) {
            product.variants.forEach(variant => {
              this.allVariants.push({
                ...variant,
                product_name: product.name,
              });
            });
          }
        });
        this.variants = this.allVariants;

        // Combine distributors, franchises, and sale executives into users
        const distributors = (data.distributors || []).map(user => ({
          id: user.id,
          display_name: `${user.name} (${user.phone || 'N/A'}) - ${user.position || ''}`
        }));

        const franchises = (data.franchises || []).map(user => ({
          id: user.id,
          display_name: `${user.name} (${user.phone || 'N/A'}) - ${user.position || ''}`
        }));

        const saleExecutives = (data.sale_executives || []).map(user => ({
          id: user.id,
          display_name: `${user.name} (${user.phone || 'N/A'}) - ${user.position || ''}`
        }));

        this.users = [...distributors, ...franchises, ...saleExecutives];

        // Transporter managers
        this.transporterManagers = (data.transporter_managers || []).map(user => ({
          id: user.id,
          display_name: `${user.name} (${user.phone || 'N/A'})`
        }));

      } catch (error) {
        console.error("Error fetching masters:", error);
      }
    },
    onProductChange() {
      // When product changes, filter variants
      this.filter.variant_id = null;

      if (this.filter.product_id) {
        this.variants = this.allVariants.filter(
          v => v.product_id === this.filter.product_id
        );
      } else {
        this.variants = this.allVariants;
      }

      this.page = 1;
      this.getData();
    },
    formatVariantName(variant) {
      let parts = [];
      if (variant.product_name) parts.push(variant.product_name);
      if (variant.color) parts.push(variant.color);
      if (variant.size) parts.push(variant.size);
      return parts.length > 0 ? parts.join(" - ") : "Variant";
    },
    async getData() {
      this.isLoading = true;
      try {
        const params = {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          show_deleted: this.isDeletePage(),
          ...this.filter,
        };

        const response = await axios.get("/assigned_stocks", { params });
        this.assignedStocks = response.data.data;
        this.count = response.data.count;
      } catch (error) {
        console.error("Error fetching assigned stocks:", error);
      } finally {
        this.isLoading = false;
      }
    },
    isDeletePage() {
      return this.$route.path.includes("deleted");
    },
    openEdit(assignedStock) {
      this.editingId = this.encryptIt(assignedStock.id);
      this.editingRow = assignedStock;
      this.showEditDialog = true;
    },
    openView(assignedStock) {
      this.viewingRow = assignedStock;
      this.showViewDialog = true;
    },
    onDialogSaved() {
      this.showCreateDialog = false;
      this.showEditDialog = false;
      this.getData();
      if (this.$toast) {
        this.$toast.success("Assigned Stock saved successfully");
      }
    },
    deleteAssignedStock(id) {
      this.selectedId = id;
      this.deleteDialog = true;
    },
    async confirmDelete() {
      try {
        await axios.post(`/assigned_stocks/delete/${this.selectedId}`);
        this.deleteDialog = false;
        this.getData();
        if (this.$toast) {
          this.$toast.success("Assigned Stock deleted successfully");
        }
      } catch (error) {
        console.error("Error deleting assigned stock:", error);
        if (this.$toast) {
          this.$toast.error("Error deleting assigned stock");
        }
      }
    },
    restoreAssignedStock(id) {
      this.selectedId = id;
      this.restoreDialog = true;
    },
    async confirmRestore() {
      try {
        await axios.post(`/assigned_stocks/restore/${this.selectedId}`);
        this.restoreDialog = false;
        this.getData();
        if (this.$toast) {
          this.$toast.success("Assigned Stock restored successfully");
        }
      } catch (error) {
        console.error("Error restoring assigned stock:", error);
        if (this.$toast) {
          this.$toast.error("Error restoring assigned stock");
        }
      }
    },
    async generateExcel() {
      this.isExcelloading = true;
      try {
        const params = {
          show_deleted: this.isDeletePage(),
          ...this.filter,
        };

        const response = await axios.get("/assigned_stocks/excel", {
          params,
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `assigned_stocks_${moment().format(
          "YYYY_MM_DD_HH_mm_ss"
        )}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);

        if (this.$toast) {
          this.$toast.success("Excel file generated successfully");
        }
      } catch (error) {
        console.error("Error generating excel:", error);
        if (this.$toast) {
          this.$toast.error("Error generating excel");
        }
      } finally {
        this.isExcelloading = false;
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
    formatVariantDisplay(variant) {
      if (!variant) return "N/A";

      let parts = [];
      if (variant.color) parts.push(variant.color);
      if (variant.size) parts.push(variant.size);

      return parts.length > 0 ? parts.join(" - ") : "N/A";
    },
  },
};
</script>

<style scoped>
.striped-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.action_th {
  min-width: 120px;
}
</style>
